import React from 'react';
import { Text } from '@sparknz/spark-pattern-library';

interface SelectedPlansDescriptionProps {
  hasTeamUpEligiblePlans: boolean;
}

const SelectedPlansDescription = ({
  hasTeamUpEligiblePlans,
}: SelectedPlansDescriptionProps) => (
  <Text variant="bodySMedium" mb="s6">
    Below is a summary of your selected plans.{' '}
    {hasTeamUpEligiblePlans ? (
      <>
        If you&apos;ve selected multiple Team&nbsp;Up plans, you&apos;ll see
        discounts applied. The more Team&nbsp;Up plans on your account, the
        greater the savings.
      </>
    ) : null}
  </Text>
);

export default SelectedPlansDescription;
